module.exports = __webpack_public_path__ + "fonts/icomoon.011b59e.eot";